import { render, staticRenderFns } from "./IconCashback.vue?vue&type=template&id=7fe14ea6&scoped=true"
import script from "./IconCashback.vue?vue&type=script&lang=js"
export * from "./IconCashback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe14ea6",
  null
  
)

export default component.exports